import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import values from 'lodash/values';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, Legend } from 'recharts';

// VARIABLES
import { CHART_COLORS } from 'globals.js';

// LOCAL COMPONENTS
import TooltipContent from './tools/Tooltip';

// STYLES
import styles from './chart.module.scss';

export default function LineChartComponent({
  className, //
  data = [],
  dataKeys = ['data'],
  dataFormat,
  axisFormat = dataFormat,
  height = 280
}) {
  return (
    <ResponsiveContainer width="100%" height={height} debounce={100} className={clsx(styles.chart, className)}>
      <LineChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <CartesianGrid horizontal={false} vertical />
        <XAxis dataKey="name" tickLine={false} tickMargin={10} />
        <YAxis tickFormatter={axisFormat} tickLine={false} allowDecimals={false} />
        <Tooltip content={<TooltipContent dataFormat={dataFormat} />} />
        <ReferenceLine y={0} />
        {dataKeys.map((dataKey, i) => {
          const color = values(CHART_COLORS)[i];
          return (
            <Line
              key={i}
              dataKey={dataKey}
              stroke={color}
              strokeWidth="2"
              fill={color}
              dot={{ stroke: color, fill: 'white', strokeWidth: 2, r: 4 }}
              activeDot={{ stroke: color, strokeWidth: 3, r: 4 }}
            />
          );
        })}
        <Legend />
      </LineChart>
    </ResponsiveContainer>
  );
}
